const SUBDOMAIN_CODE_PATTERN = /^([A-Z]+[0-9]*)\s*/;

export interface ParsedSubdomainName {
  code: string;
  label: string;
}

export function parseSubdomainName(rawName: string): ParsedSubdomainName {
  const sanitized = rawName.trim();
  const segments = sanitized.split("-");
  const tailSegment = segments.length > 1 ? segments[segments.length - 1].trim() : sanitized;

  const tailMatch = tailSegment.match(SUBDOMAIN_CODE_PATTERN);

  if (tailMatch) {
    const code = tailMatch[1];
    const label =
      tailSegment.replace(SUBDOMAIN_CODE_PATTERN, "").trim() ||
      sanitized.replace(SUBDOMAIN_CODE_PATTERN, "").trim() ||
      sanitized;
    return { code, label };
  }

  const headMatch = sanitized.match(SUBDOMAIN_CODE_PATTERN);
  if (headMatch) {
    const code = headMatch[1];
    const label = sanitized.replace(SUBDOMAIN_CODE_PATTERN, "").trim() || sanitized;
    return { code, label };
  }

  throw new Error(`Unable to parse subdomain code from "${rawName}"`);
}
